import {useEffect, useMemo, useState} from "react";
import {InputText} from "./form/InputText";
import {InputTextarea} from "./form/InputTextarea";
import {Button} from "./form/Button";
import {orderCorrespondenceLabels, orderCorrespondenceType} from "../js/constants";
import {get} from "../js/api";
import {RefreshSignal, useChangeEffect, useRefreshEffect} from "../js/util";

export const OrderCorrespondence = ({identifier, isPublic = false, adminView = true, onCreateReply = null, refresh = new RefreshSignal()}) => {

    const [messages, setMessages] = useState([]);

    const [reply, setReply] = useState();

    const adminMessages = useMemo(() => [orderCorrespondenceType.information, orderCorrespondenceType.question, orderCorrespondenceType.keycard], []);
    const usrMessages = useMemo(() => [orderCorrespondenceType.user_response], []);
    const messageTypes = useMemo(() => adminView ? adminMessages : usrMessages, [adminView]);

    const loadMsgs = () => {
        if(!isPublic){
            get(`/orders/${identifier}/correspondence`).then(resp => setMessages(resp));
        }else {
            get(`/public/orders/${identifier}/correspondence`).then(resp => setMessages(resp));
        }

        if(messageTypes.length == 1){
            setReply({...Reply_Templates.find(templ => templ.type === messageTypes[0])})
        }else{
            setReply(null)
            onCreateReply(null)
        }
    }

    useEffect(loadMsgs, [identifier, isPublic]);

    useRefreshEffect(() => {
        loadMsgs();
    }, refresh);


    const showLeftSpacer = (message) => {
        let show = message.type === orderCorrespondenceType.user_response;
        if(adminView){
            show = !show;
        }
        return show;
    }

    const showRightSpacer = (message) => {
        let show = message.type !== orderCorrespondenceType.user_response;
        if(adminView){
            show = !show;
        }
        return show;
    }

    const update = (val, prop) => {
        const cpy = {...reply}
        cpy[prop] = val;
        setReply(cpy);
        onCreateReply(cpy);
    }

    return (<>
        <h2>Kommunikation</h2>

        {messages.length > 0 && <>
            <h3>Verlauf</h3>
            <div className={"correspondence-history"}>
                {messages.length > 0 && messages.map(m => {
                    return <div className={"correspondence-row"} key={m.id}>
                            {showLeftSpacer(m) &&
                            <div className={"correspondence-spacer"}/>}
                            <div className={"correspondence-entry " + (showLeftSpacer(m) ? 'sender-style' : '')}>
                                <div className={"mt-1 mb-0"}><small>{orderCorrespondenceLabels.get(m.type)}</small></div>
                                <h4 className={"mt-0"}>
                                    {m.subject}
                                </h4>
                                <span>{m.text}</span>
                            </div>
                            {showRightSpacer(m) &&
                                <div className={"correspondence-spacer"}/>}
                        </div>
                })}
            </div>
        </>}
        {messages.length == 0 && <div>
            Keine Nachrichten
        </div>
        }

        {onCreateReply && <>
            <h3>Antwort</h3>
            <div>
                {messageTypes.map(t => {
                    return <Button key={t}
                            theme={"blue mr-1 mb-1 " + (reply?.type === t ? 'active' : '')}
                            width={230} onClick={() => setReply({...Reply_Templates.find(templ => templ.type === t)})}>{orderCorrespondenceLabels.get(t)}</Button>
                })}
            </div>
            { reply &&
            <div className="default">
                <InputText label={"Betreff"} name="subject" value={reply.subject} setter={update} required={true}/>
                <InputTextarea label={"Nachricht"} name="text" value={reply.text} setter={update} rows={5} required={true}/>
            </div>}
        </>
        }
    </>)
}

export const Reply_Template_Identification = {
    subject: 'Schlüsselkarte benötigt',
    text: 'Bei Ihrem Schlüssel handelt es sich um einen gesicherten Schlüssel, wir benötigen daher bitte die noch die Schlüsselkarte.\n',
    type: orderCorrespondenceType.keycard
}

export const Reply_Template_Question = {
    subject: 'Rückfrage',
    text: 'Zur Abarbeitung benötigen wir noch folgende Informationen:\n',
    type: orderCorrespondenceType.question
}

export const Reply_Template_Notification = {
    subject: 'Information',
    text: '',
    type: orderCorrespondenceType.information
}

export const Reply_Template_User_Response = {
    subject: 'Antwort',
    text: '',
    type: orderCorrespondenceType.user_response
}


export const Reply_Templates = [Reply_Template_Identification, Reply_Template_Question, Reply_Template_Notification, Reply_Template_User_Response]
